import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { compose } from 'redux';
import { connect } from 'react-redux';

import {
  Button,
  Segment,
  Text,
  Title,
} from './styles';

const InstructionsTester = (props) => {
  const {
    history,
    projectReducer,
  } = props;

  const instructionsTitle = _.get(projectReducer, 'instructionsTitle', '');
  const instructionsContent = _.get(projectReducer, 'instructionsContent', '');

  const handleClick = () => {
    history.push('/tree-test-task');
  };

  return (
    <Segment>
      <Title>{instructionsTitle}</Title>
      <Text>{instructionsContent}</Text>
      <Button onClick={handleClick} data-tester-test-proceed-instructions>
        Next
      </Button>
    </Segment>
  );
};

const mapStateToProps = ({ treeTest }) => ({
  projectReducer: treeTest.project || {},
});

const enhance = compose(
  connect(mapStateToProps, null),
);

InstructionsTester.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  projectReducer: PropTypes.shape({
    id: PropTypes.string,
  }),
};

InstructionsTester.defaultProps = {
  projectReducer: {},
};

export default enhance(InstructionsTester);
